import { useRef, useState } from "react";
import PageWrapper from "./PageWrapper";
import { acknowledgeExternalTestIntro } from "../service/api";
import { retryApiCall } from "../utils/retry";

const FinalComparisonIntro = ({ userId, sessionId, onContinue, onComplete }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const submissionLockRef = useRef(false);

  const acknowledge = async () => {
    if (submissionLockRef.current) return;
    submissionLockRef.current = true;
    setIsSubmitting(true);
    setError(null);
    try {
      const response = await retryApiCall(() =>
        acknowledgeExternalTestIntro({ userId, sessionId })
      );
      if (!response.ok) throw new Error(response.message || "Could not continue");
      if (response.phase === "complete") onComplete();
      else onContinue();
    } catch (caught) {
      console.error("Failed to acknowledge final comparison introduction:", caught);
      setError("We couldn’t save that confirmation. Please try again.");
    } finally {
      submissionLockRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <PageWrapper>
      <div style={{ textAlign: "center" }} data-testid="final-comparison-intro">
        <h2>Final comparison phase</h2>

        <p>You have completed the personalized part of the study.</p>

        <p>
          Next, you will see 20 additional movie comparisons. These pairs are standardized, so some may feel less tailored than the ones you have just seen.
        </p>

        <p>
          Please answer in the same way as before. There are no right or wrong answers.
        </p>

        <p>These final comparisons will not affect the personalization.</p>

        {error && <p role="alert" style={{ color: "var(--color-error)", fontWeight: "bold" }}>{error}</p>}

        <div style={{ marginTop: "30px", display: "flex", justifyContent: "center" }}>
          <button
            type="button"
            onClick={acknowledge}
            className="submit-button"
            disabled={isSubmitting}
            data-testid="final-comparison-start-task"
          >
            {isSubmitting ? "Saving..." : "✅ Start Task"}
          </button>
        </div>
      </div>
    </PageWrapper>
  );
};

export default FinalComparisonIntro;
